// Port of api/fuel/app/classes/insights/game/locations.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'locations',
    priority: 1,
    requires: ['init'],
    insight: false,
    detail: ['locations'],
    types: [Constants.TYPE_USER],
    run: function(type, owner, userIndex, detail, filter, vars) {

        if (!this._data.has_plays) return {}

        var user_id = owner.get_id()
        var game_id = parseInt(vars.id, 10)

        var locationsRaw = Util.queryFast(
            'SELECT LOWER(TRIM(p.play_location)) AS name, SUM(p.play_count) AS count ' +
            'FROM play p ' +
            'WHERE p.user_id = ' + user_id + ' AND p.game_id = ' + game_id +
            ' AND p.play_location <> "" ' +
            'GROUP BY LOWER(TRIM(p.play_location))'
        )

        return {
            locations: Util.sort_by_field(locationsRaw, 'count', 'desc')
        }

    }
})
